// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "intl-messages0" + "." + "79af3f741d799d6d" + ".js";
};